// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** Get list pbac GET /api/v1/pbac */
export async function pbacList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.pbacListParams,
  options?: { [key: string]: any },
) {
  return request<API.PBACListDto>('/api/v1/pbac', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** Create pbac POST /api/v1/pbac */
export async function pbacAdd(
  body: API.CreatePBACParamDto,
  options?: { [key: string]: any },
) {
  return request<API.PBAC>('/api/v1/pbac', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** Get pbac detail GET /api/v1/pbac/${param0} */
export async function pbacDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.pbacDetailParams,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<API.PBAC>(`/api/v1/pbac/${param0}`, {
    method: 'GET',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** Update pbac PUT /api/v1/pbac/${param0} */
export async function pbacUpdate(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.pbacUpdateParams,
  body: API.UpdatePBACParamDto,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<API.PBAC>(`/api/v1/pbac/${param0}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  });
}

/** Delete pbac DELETE /api/v1/pbac/${param0} */
export async function pbacDelete(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.pbacDeleteParams,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/api/v1/pbac/${param0}`, {
    method: 'DELETE',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** Change pbac status PATCH /api/v1/pbac/status */
export async function pbacChangeStatus(
  body: API.ChangeManyStatusParamDto,
  options?: { [key: string]: any },
) {
  return request<any>('/api/v1/pbac/status', {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
